import {helpers} from '@teamrazr/redux'

const reviewReducer = helpers.createApiReducer('product_reviews')

export default function productReview(state = {items: [], count: 0}, action) {
  switch (action.type) {
    case 'RESET_PRODUCT_REVIEWS':
      return {loading: false, items: []}

    case 'GET_PRODUCT_REVIEWS_SUCCESS': {
      const items = action.append
        ? state.items.concat(action.body.reviews)
        : action.body.reviews

      const count = action.body.count ? action.body.count : state.count

      return {loading: false, items, count}
    }
    default:
      return reviewReducer(state, action)
  }
}
